export default __webpack_public_path__ + "static/media/LHLogo.dc67ff84.png";